import { createFileRoute } from "@tanstack/react-router";
import Pricing from "@/components/Pricing";
import CTA from "@/components/LandingPage/CTA";
import { getUserGeoData } from "@/lib/geo.server";

export const Route = createFileRoute("/$lang/pricing")({
  loader: async () => {
    const geoData = await getUserGeoData();
    return { geoData };
  },
  component: LangPricingPage,
});

function LangPricingPage() {
  const { geoData } = Route.useLoaderData();

  return (
    <div className="min-h-screen relative overflow-hidden bg-white dark:bg-black transition-colors duration-300">
      <div className="absolute inset-0 bg-white/50 dark:bg-black/20 [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] pointer-events-none"></div>

      <div className="relative z-10 pt-20">
        <Pricing countryCode={geoData.countryCode} currency={geoData.currency} />
      </div>
      <CTA />
    </div>
  );
}
